<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    id="reload-repeat-arrows-loading"
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
  >
    <g id="Group_1196" data-name="Group 1196" transform="translate(2.5 2.5)">
      <path
        id="Path_8537"
        data-name="Path 8537"
        d="M15.8,5.2A7.5,7.5,0,1,1,5.2,5.2,7.5,7.5,0,0,1,15.8,5.2"
        transform="translate(-3 -3)"
        fill="none"
        :stroke="clr ? clr : '#3889d0'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8538"
        data-name="Path 8538"
        d="M15.15,11.9l.729.781.729-.781"
        transform="translate(-5.025 -4.483)"
        fill="none"
        :stroke="clr ? clr : '#3889d0'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8539"
        data-name="Path 8539"
        d="M9.266,8.489a3.415,3.415,0,0,1,5.272,3.5M8.558,11.33l-.729-.78-.729.78"
        transform="translate(-3.683 -3.816)"
        fill="none"
        :stroke="clr ? clr : '#3889d0'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
      <path
        id="Path_8540"
        data-name="Path 8540"
        d="M13.233,14.609a3.386,3.386,0,0,1-1.917.594,3.416,3.416,0,0,1-3.354-4.092"
        transform="translate(-3.816 -4.352)"
        fill="none"
        :stroke="clr ? clr : '#3889d0'"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
      />
    </g>
    <path id="Path_8541" data-name="Path 8541" d="M0,0H20V20H0Z" fill="none" />
  </svg>
</template>
